import { DatePipe, JsonPipe } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { NavigationExtras, Router } from '@angular/router';
import { MenuItemModel } from 'src/app/core/models/analytics/menu-item-model';
import { ItemIdModel } from 'src/app/core/models/filter-model/item-id-model';
import { BulkInsertModel } from 'src/app/core/models/impact-assessment/bulk-insert-model';
import { ImpactAssessmentDropDownList } from 'src/app/core/models/impact-assessment/impact-assessment-dropdown-list-model';
import { ImpactAssessment4 } from 'src/app/core/models/impact-assessment/impact-assessment4';
import { ImpactAssessmentT4DetailListModel } from 'src/app/core/models/impact-assessment/impact-assessmentT4-detail-list-model';
import { ImpactAssessmentT4DetailsDD } from 'src/app/core/models/impact-assessment/impact-assessmentT4-details-dd';
import { JurisdictionsList } from 'src/app/core/models/impact-assessment/jurisdictions-list-model';
import { LinkedAssessmentModel } from 'src/app/core/models/impact-assessment/linked-assessment-model';
import { LinkedIdModel } from 'src/app/core/models/impact-assessment/linked-id-model';
import { UpdateImpactAssessmentT4Model } from 'src/app/core/models/impact-assessment/updateImpactAssessmentT4Model';
import { FilterViewModel } from 'src/app/core/models/regulation';
import { BulkCloseModel } from 'src/app/core/models/regulation/bulk-close-model';
import { RegulationDetail, RegulationDetailDto } from 'src/app/core/models/regulation/regulation-detail';
import { UserProfile } from 'src/app/core/models/user';
import { UserDetailModel, UserFilterModel } from 'src/app/core/models/user-management/user-filter-model';
import { AlertDialogModel, ToastViewModel } from 'src/app/core/models/view-model';
import { DownloadReportModel } from 'src/app/core/models/view-model/download-report-model';
import { VersionHistoryFilterModel } from 'src/app/core/models/view-model/version-history-filter-model';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { CommonService } from 'src/app/core/services/common/common.service';
import { ImpactService } from 'src/app/core/services/impact/impact.service';
import { RegulationService } from 'src/app/core/services/regulation';
import { GDPRService } from 'src/app/core/services/rulebook';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';
import { MasterHelper } from 'src/app/core/utilities';
import { DeleteDialogComponent } from '../../distributed-ui-components';
import { BulkCloseDialogComponent } from '../../distributed-ui-components/bulk-close-dialog/bulk-close-dialog.component';
import { ChangeViewerDialogComponent } from '../../distributed-ui-components/change-viewer-dialog/change-viewer-dialog.component';
import { ImpactAssessmentDialogComponent } from '../../impact-assessment/impact-assessment-dialog/impact-assessment-dialog.component';
import { TimePickerComponent } from '../time-picker/time-picker.component';
//import * as customBuild from './../../../../ckCustomeBuild/build/ckeditor';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-impact-assessment-template4',
  templateUrl: './impact-assessment-template4.component.html',
  styleUrls: ['./impact-assessment-template4.component.scss']
})
export class ImpactAssessmentTemplate4Component implements OnInit {

  impactAssessment: ImpactAssessment4;
  impactAssessmentDD: ImpactAssessmentT4DetailsDD;
  updateIADetails: UpdateImpactAssessmentT4Model;
  iaDetailHistory: ImpactAssessmentT4DetailListModel;

  isAuthorised = true;
  isLoading = false;
  toastModel: ToastViewModel;
  currentUserRole = '';
  searchStr = '';
  isSavedPermission = false;
  isSaved = false;
  isParentIdEdit: boolean = false;
  parentId: number = 0;
  isToastShow = false;
  isIADetails1 = false;
  isIADetails2 = false;
  isIADetails3 = false;
  isIADetails4 = false;
  isADetailPermission = true;
  isAssessmentLastEdited = false;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  isAssessmentClose = false;

  libraryMenu: Array<MenuItemModel>;
  userAccessToken: UserProfile;
  linkedAssessment: LinkedAssessmentModel;
  linkedAssessmentIds: Array<LinkedIdModel>;
  downloadReportModel: DownloadReportModel;
  regulationInfo: RegulationDetail;
  userFilter: UserFilterModel;
  userJurisdiction: Array<FilterViewModel>;
  bulkCloseData: BulkCloseModel;
  alertDialogModel: AlertDialogModel;
  assessmentStatus: Array<string> = [];
  // dropdownData:Array<string> = [];
  jurisdictions!: JurisdictionsList;
  searchedJurisdiction!: any[];
  isLoadingDD = false;
  searchedTopics: FilterViewModel[] = [];
  allSearchedTopic: FilterViewModel[] = [];
  searchTopicCntrl: FormControl = new FormControl();
  searchAssessorCntrl: FormControl = new FormControl();
  myTopicDD!: Expertise[];
  dropdownData: Expertise[] = [];
  currentinfoId: number = 0;

  searchedJuris: ItemIdModel[] = [];
  selectedJuris: ItemIdModel[] = [];
  searchedAssessor: FilterViewModel[] = [];
  allSearchedAssessor: FilterViewModel[] = [];

  assessorDD: string[] = [];

  @Input()
  filterType!: string;
  @Input()
  impactAssessmentId!: number;
  filterScreenType = '';

  @ViewChild('assessorAutocomplete')
  assessorAutocomplete!: MatAutocomplete;
  @ViewChild('assessorInput')
  assessorInput!: ElementRef<HTMLInputElement>;
  @ViewChild('trigautoAssessor')
  trigautoAssessor!: MatAutocompleteTrigger;
  //public Editor = customBuild;
  @Input()
  idList: number[]=[];

  constructor(
    private impactService: ImpactService, public dialog: MatDialog, public commonService: CommonService, public http: HttpClient,
    private regulationService: RegulationService, private userService: UserManagementService,
    private sessionService: SessionService, public router: Router, private jsonPipe: JsonPipe, private datePipe: DatePipe,
    private gdprService: GDPRService,public sanitizer: DomSanitizer
  ) {
    this.impactAssessment = new ImpactAssessment4();
    this.toastModel = new ToastViewModel();
    this.impactAssessmentDD = new ImpactAssessmentT4DetailsDD();
    this.updateIADetails = new UpdateImpactAssessmentT4Model();
    this.toastModel = new ToastViewModel();
    this.libraryMenu = [];
    this.userAccessToken = new UserProfile();
    this.impactService.detailTabActive = true;
    this.linkedAssessment = new LinkedAssessmentModel();
    this.linkedAssessmentIds = [];
    this.iaDetailHistory = new ImpactAssessmentT4DetailListModel();
    this.downloadReportModel = new DownloadReportModel();
    this.regulationInfo = new RegulationDetail();
    this.userFilter = new UserFilterModel();
    this.userJurisdiction = [];
    this.bulkCloseData = new BulkCloseModel();
    this.alertDialogModel = new AlertDialogModel();
  }

  ngOnInit(): void {
    this.filterScreenType = this.filterType;
    this.getUserProfile();
  }

  getImpactAssesmentDropdownList(jurisdiction: string): void {
    this.impactService.getImpactAssesmentDropDownList(jurisdiction).subscribe((result: ImpactAssessmentDropDownList) => {
      result.currentStatus.forEach(element => {
        this.assessmentStatus.push(element.title)
      });
       result.dropdownForTemp4.forEach(element => {
         this.dropdownData.push(element)
       });
    });
  }

  getUserProfile(): void {
    this.sessionService.getLoginUserInfo().subscribe((result: UserProfile) => {
      this.userAccessToken = result;
      this.checkUserIAAuthentication();
      if (this.userAccessToken) {
        this.fetchUserDetails();
      }
    });
  }

  openLinkedAssessment(id: number): void {
    if (this.filterType === 'PopupWindow') {
      this.impactAssessmentId = id;
      this.fetchImpactAssessmentDetails();
      this.fetchIADetailsHistory();
      this.fetchJurisdiction();
      this.fetchImpactAssessmentDD();
    } else {
      window.location.href = '/impact-assessment/details/impact/' + this.impactAssessment.templateNo + '/'  + id;
    }
  }

  fetchImpactAssessmentDD(): void {
    this.isLoadingDD = true;
    this.impactService.getImpactAssessmentT4DD().subscribe((result: ImpactAssessmentT4DetailsDD) => {
      this.isLoadingDD = false;
      this.impactAssessmentDD = result;
      this.ddListData();
      this.selectedDDvalue();
    });
  }

  selectedDDvalue(): void {
    this.assessorDD = this.impactAssessment.assessor ? this.impactAssessment.assessor.split(',') : this.assessorDD;
    
    if (this.impactAssessment.jurisdiction) {
      this.impactAssessment.jurisdiction.split(',').forEach(juris => {
        this.selectedJuris.push({ id: 0, name: juris });
      });
    }
  }

  ddListData(): void {
    this.searchedAssessor = this.impactAssessmentDD.assessor;
    this.allSearchedAssessor = this.impactAssessmentDD.assessor;
    
    this.searchedJuris = this.impactAssessmentDD.jurisdiction;
    this.searchedTopics = this.impactAssessmentDD.ruleTopics;

    this.allSearchedTopic = this.impactAssessmentDD.ruleTopics;

    this.searchTopicCntrl.valueChanges.subscribe((term: any) => {
      this.searchedTopics = term ? this.filterTopic(term) : this.impactAssessmentDD.ruleTopics;
    });
    this.searchAssessorCntrl.valueChanges.subscribe((term: any) => {
      this.searchedAssessor = term ? this.filterAssessor(term) : this.impactAssessmentDD.assessor;
      this.searchedJurisdiction = term ? this.filterJurisdiction(term) : this.jurisdictions.jurisdictions;
    });
  }

  fetchIADetailsHistory(): void {
    this.impactService.getIAT4DetailsHistory(this.impactAssessmentId).subscribe((result: ImpactAssessmentT4DetailListModel) => {
      this.iaDetailHistory = result;
    });
  }

  fetchJurisdiction(): void {
    this.impactService.GetJurisdictionsList().subscribe((result: JurisdictionsList) => {
      this.jurisdictions = result;

      this.searchedJurisdiction = this.jurisdictions.jurisdictions;
    })
  }

  // Topic multiselect
  filterTopic(search: string): any {
    return this.searchedTopics.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  fetchUserDetails(): void {
    this.userService.getUserDetails().subscribe((result: UserDetailModel) => {
      this.userJurisdiction = result.userJurisdiction;
      this.libraryMenu = result.libraryMenu;
      this.currentUserRole = result && result.role.title ? result.role.title : '';
      this.fetchImpactAssessmentDetails();
      if (this.filterType !== 'version') {
        this.fetchIADetailsHistory();
      }
      this.fetchJurisdiction();
      this.fetchImpactAssessmentDD();
    });
  }

  checkUserIAAuthentication(): void {
    this.impactService.getIAUsers(this.impactAssessmentId).subscribe((result: string[]) => {
      this.isSavedPermission = result.indexOf(this.userAccessToken.fullName) >= 0 ? true : false;
    });
  }

  getLinkedIds(): void {
    this.impactService.getLinkedIds(this.impactAssessment.previousImpactAsss_Id).subscribe((result: LinkedIdModel[]) => {
      this.linkedAssessmentIds = result;
    });
  }

  fetchImpactAssessmentDetails(): void {
    this.isLoading = true;
    this.impactService.getImpactAssessmentT4Details(this.impactAssessmentId, this.filterType)
      .subscribe((result: ImpactAssessment4) => {
        this.impactAssessment = result;
        this.getImpactAssesmentDropdownList(result.jurisdiction);
        this.impactAssessment.ruleType = this.impactAssessment.ruleType ? this.impactAssessment.ruleType : 'Draft Rule';
        this.impactAssessment.projectReference = this.impactAssessment.projectReference ? this.impactAssessment.projectReference : 'Not Applicable';
        this.isLoading = false;
        if (this.impactAssessment.previousImpactAsss_Id) {
          this.getLinkedIds();
        }
        // this.checkUserPermission();
        this.fetchPermissionByJurisdiction(this.userJurisdiction);
        this.currentinfoId = this.impactAssessment.updatedDB_Id;
      });
  }

  fetchPermissionByJurisdiction(userJurisdiction: FilterViewModel[]): void {
    if (this.currentUserRole !== 'Compliance Enterprise') {
      if (this.impactAssessment.jurisdiction) {
        const jurisArr = this.impactAssessment.jurisdiction.split(',');
        jurisArr.forEach(element => {
          if (!userJurisdiction.some(a => a.value === element) && this.impactAssessment.isHidden) {
            this.isAuthorised = false;
          }
        });
      }
    } else {
      this.isAuthorised = true;
    }
  }

  updateOtherMergedId(item: any) {
    this.openDeleteDialogForLinkedId(item);
  }
  openDeleteDialogForLinkedId(item: any): void {
    this.alertDialogModel.HeadingText = 'Delete Item';
    this.alertDialogModel.BodyText = 'Are you sure you want to delete this Linked Id ' + item + ' ?';
    this.alertDialogModel.ActionButtonText = 'Delete';
    this.alertDialogModel.IsAction = true;

    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: '450px',
      data: this.alertDialogModel
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Delete Item') {
        item = Number(item);
        const bulkInsertModel = new BulkInsertModel();
        bulkInsertModel.screenUrl = this.router.url;
        let itemids = this.impactAssessment.merged_Id.replace('(', '');
        itemids = itemids.replace(')', '');
        bulkInsertModel.itemIds = itemids.split(",").map(Number);
        const index = bulkInsertModel.itemIds.indexOf(item);
        bulkInsertModel.itemIds.splice(index, 1);
        bulkInsertModel.parentId = this.impactAssessment.updatedDB_Id;
        bulkInsertModel.id = this.impactAssessment.id;
        this.isLoading = true;
        this.gdprService.moveToBulkImpactAssessmentT4(bulkInsertModel).subscribe((data: any) => {
          this.isLoading = false;
          let otherIds = bulkInsertModel.itemIds.map(x => x).join(",");
          this.impactAssessment.merged_Id = otherIds;
        });
      }
    });
  }

  updateParentId() {
    this.parentId = this.impactAssessment.updatedDB_Id;
    this.isParentIdEdit = true;
  }
  changeParentId() {
    const bulkInsertModel = new BulkInsertModel();
    //this.isLoading = true;
    bulkInsertModel.screenUrl = this.router.url;
    let itemids = this.impactAssessment.merged_Id.replace('(', '');
    itemids = itemids.replace(')', '');
    bulkInsertModel.itemIds = itemids.split(",").map(Number);
    bulkInsertModel.parentId = this.parentId;
    bulkInsertModel.id = this.impactAssessment.id;
    if (this.impactAssessment.updatedDB_Id != this.parentId) {
      this.isLoading = true;
      this.gdprService.moveToBulkImpactAssessmentT4(bulkInsertModel).subscribe((data: any) => {
        this.impactAssessment.updatedDB_Id = this.parentId
        this.isParentIdEdit = false;
        this.isLoading = false;
        // this.successAlert("Impact merge successfully");
      });
    }
    else {
      this.isParentIdEdit = false;
    }

  }

  getUpdatedDbInfo(id: number) {
    if (this.currentinfoId != id) {
      this.isLoading = true;
      this.impactService.getImpactAssessmentRegulationDetails(id).subscribe((data: ImpactAssessment4) => {
        this.impactAssessment.title = data.title;
        this.impactAssessment.description = data.description;
        this.impactAssessment.pubType = data.pubType;
        this.impactAssessment.geography = data.geography;
        this.impactAssessment.regulator = data.regulator;
        this.impactAssessment.updatedDB_Date = data.updatedDB_Date;
        this.impactAssessment.country = data.country;
        this.currentinfoId = id;
        this.isLoading = false;
      });
    }

  }

  addAssessor(event: MatChipInputEvent): void {
    const value = event.value;
    if (!this.assessorAutocomplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.assessorDD.filter(
          obj => obj === value);

        if (sameValueRow.length == 0) {
          (this.assessorDD as string[]).push(value);
        }
      }
      event.chipInput!.clear();
      this.searchAssessorCntrl.setValue(null);
      this.updateSectionLastEdited('Assessor');
    }
  }

  selectedAssessorEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.assessorDD) {
      let sameValueRow = this.assessorDD.filter(
        obj => obj === event.option.viewValue);
      if (sameValueRow.length == 0) {
        this.assessorDD.push(event.option.viewValue);
      }
    } else {
      this.assessorDD = [];
      this.assessorDD.push(event.option.viewValue);
    }
    if (this.assessorInput) {
      this.assessorInput.nativeElement.value = '';
    }
    this.searchAssessorCntrl.setValue(null);
    this.searchAssessorCntrl.disable();
    this.searchAssessorCntrl.enable();
    this.updateSectionLastEdited('Assessor');
  }

  removeAssessor(status: string): void {
    const index = (this.assessorDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.assessorDD as string[]).splice(index, 1);
      this.updateSectionLastEdited('Assessor');
    }
  }

  @HostListener('window:scroll', ['$event'])
  scrollHandler(event: any) {

    if (this.assessorAutocomplete?.isOpen) {
      this.trigautoAssessor.closePanel();
      this.assessorInput.nativeElement.blur();
    }
  }

  // Assessor multiselect
  filterAssessor(search: string): any {
    return this.searchedAssessor.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  filterJurisdiction(search: string): any {
    return this.searchedJurisdiction.filter(option =>
      option.title.toLowerCase().includes(search.toLowerCase())
    );
  }

  getFilteredData(filter: string, event: any): void {
    this.searchStr += event.key;
    switch (filter) {
      case 'Assessor':
        const searchedA = Array<FilterViewModel>();
        if (this.searchedAssessor.length > 0) {
          this.searchedAssessor.forEach(element => {
            if (element.value.toLowerCase().includes(this.searchStr.toLowerCase())) {
              searchedA.push(element);
            }
          });
          this.searchedAssessor = searchedA;
        } else {
          this.searchedAssessor = this.allSearchedAssessor;
        }
        break;
      case 'Topic':
        const searchedT = Array<FilterViewModel>();
        if (this.searchedTopics.length > 0) {
          this.searchedTopics.forEach(element => {
            if (element.value.toLowerCase().includes(this.searchStr.toLowerCase())) {
              searchedT.push(element);
            }
          });
          this.searchedTopics = searchedT;
        } else {
          this.searchedTopics = this.allSearchedTopic;
        }
        break;
    }
    this.searchStr = '';
  }

  checkUserPermission(): void {
    if (this.currentUserRole !== 'Compliance Enterprise' && this.currentUserRole !== 'Horizon Scanning SuperUser'
      && this.impactAssessment.userId !== this.userAccessToken.externalUserId) {
      // Assessment Details Permission
      this.isADetailPermission = this.impactAssessment.assessor &&
        (this.impactAssessment.assessor.split(',') as string[]).indexOf(this.userAccessToken.fullName) >= 0 ? true : false;
    }
  }

  //Update Impact Assessment
  updateImpactAssessment(): void {
    if (this.selectedJuris.length === 0) {
      this.alertMessage('warning', 'Please select jurisdiction');
    } else {
      if (this.impactAssessment.isRecordTime) {
        const dialogRef = this.dialog.open(TimePickerComponent, {
          width: '330px',
          panelClass: 'custom-time-modal'
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.impactAssessment.timeSpent = this.impactAssessment.timeSpent + result;
            this.updateImpactAssessmentDetails();
          }
        });
      }
      else {
        this.updateImpactAssessmentDetails();
      }

    }
  }

  alertMessage(type: string, message: string): void {
    if (type === 'success') {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
    } else {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
    }
    this.toastModel.Message = message;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 3000);
  }

  updateImpactAssessmentDetails(): void {
    this.isSaved = true;
    this.isLoading = true;
    
    this.impactAssessment.assessor = this.assessorDD.toString();
    
    this.impactAssessment.jurisdiction =
      this.selectedJuris.length > 0 ? MasterHelper.getStringFromObjectArray(this.selectedJuris) : '';
    if (this.myTopicDD != null) {
      this.impactAssessment.ruleTopic = JSON.stringify(this.myTopicDD);
    }
    this.impactAssessment.applicationDate = this.impactAssessment.applicationDate ?
      MasterHelper.bsdatePickerToCorrectDate(this.impactAssessment.applicationDate.toString()) : null;
    this.impactAssessment.lastUpdate = this.impactAssessment.lastUpdate ?
      MasterHelper.bsdatePickerToCorrectDate(this.impactAssessment.lastUpdate.toString()) : null;
    this.impactAssessment.userId = this.userAccessToken.externalUserId;
    this.impactAssessment.userName = this.userAccessToken.fullName;
    const currentUrl = window.location.href;
    this.updateIADetails.impactAssessment = this.impactAssessment;
    this.impactService.updateImpactAssessmentT4(this.updateIADetails, currentUrl).subscribe((result: ImpactAssessment4) => {
      this.isLoading = false;
      this.impactAssessment = result;
      this.alertMessage('success', 'Successfully updated');
      this.isSaved = false;
      this.updateIADetails = new UpdateImpactAssessmentT4Model();
      this.fetchIADetailsHistory();
      if (result.previousImpactAsss_Id) {
        this.getLinkedIds();
      }
    });
  }

  openDialog(): void {
    const filterDataModel = new VersionHistoryFilterModel();
    filterDataModel.id = this.impactAssessment.id;
    filterDataModel.versionId = this.impactAssessmentId;
    filterDataModel.filterType = this.filterScreenType;
    filterDataModel.templateNo = this.impactAssessment.templateNo;
    const dialogRef = this.dialog.open(ImpactAssessmentDialogComponent, {
      width: '750px',
      data: filterDataModel
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (this.filterScreenType === 'PopupWindow' && result) {
        this.filterType = 'version';
        this.impactAssessmentId = +result;
        this.fetchImpactAssessmentDetails();
        this.fetchJurisdiction();
        this.fetchImpactAssessmentDD();
      }
    });
  }

  backToCurrentVersion(): void {
    if (this.filterScreenType === 'PopupWindow') {
      this.filterType = this.filterScreenType;
      this.impactAssessmentId = this.impactAssessment.id;
      this.fetchImpactAssessmentDetails();
      this.fetchIADetailsHistory();
      this.fetchJurisdiction();
      this.fetchImpactAssessmentDD();
    } else {
      window.location.href = 'impact-assessment/details/impact/' + this.impactAssessment.templateNo + '/' + this.impactAssessment.id;
    }
  }

  openRegulationDialog(): void {
    this.regulationInfo.regulationId = this.impactAssessment.updatedDB_Id;
    this.regulationInfo.title = this.impactAssessment.title;
    this.regulationInfo.type = this.impactAssessment.pubType;
    this.regulationInfo.filterType = 'Linked Updates';
    this.regulationInfo.TabType = this.filterScreenType;
    const dialogRef = this.dialog.open(ChangeViewerDialogComponent, {
      width: '1000px',
      data: this.regulationInfo
    });
    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        this.isAssessmentClose = true;
        if (result.selectedLinkedIds && result.selectedLinkedIds.length > 0) {
          result.selectedLinkedIds.push(this.impactAssessment.updatedDB_Id);
          this.bulkCloseRegulations(result, 'Close');
        } else {
          this.updateRegulationDetail(result, this.impactAssessment.updatedDB_Id);
        }
      } else {
        this.regulationInfo = new RegulationDetail();
      }
    });
  }

  updateRegulationDetail(regulation: RegulationDetail, id: number): void {
    regulation.regulationId = id;
    regulation.userId = this.userAccessToken.externalUserId;
    regulation.isRead = true;
    regulation.status = +regulation.status;
    const regDto = new RegulationDetailDto();
    regDto.regulationDetails = regulation;
    regDto.screenName = 'Impact Assessment Details';
    this.regulationService.moveToRegulationDetail(regDto).subscribe(() => {
      this.alertMessage('success', 'Successfully updated');
      if (this.isAssessmentClose) {
        if (this.router.url.indexOf('/impact-assessment/details/') >= 0) {
          this.router.navigate([
            "/impact-assessment/summary/"
          ]);
        }
        else if (this.router.url.includes('/change-viewer')) {
          this.dialog.closeAll();
        }
        this.isAssessmentClose = false;
      }
    });
    //}
  }

  bulkCloseRegulations(regDetails: RegulationDetail, filter: string): void {
    this.bulkCloseData.itemIds = regDetails.selectedLinkedIds;
    regDetails.userId = this.userAccessToken.externalUserId;
    regDetails.isRead = true;
    this.bulkCloseData.regulationDetail = regDetails;
    if (this.bulkCloseData.itemIds && this.bulkCloseData.itemIds.length > 50) {
      this.warningAlert('This operation may take a while to complete. The page will refresh upon completion. Please wait...');
    }
    this.bulkCloseData.regulationDetail.title = '';
    this.regulationService.regulationBulkClose(this.bulkCloseData).subscribe((result: any) => {
      this.alertMessage('success', 'Successfully updated');
      if (this.isAssessmentClose) {
        if (this.router.url.indexOf('/impact-assessment/details/') >= 0) {
          this.router.navigate([
            "/impact-assessment/summary/"
          ]);
        }
        else if (this.router.url.includes('/change-viewer')) {
          this.dialog.closeAll();
        }
        this.isAssessmentClose = false;
      }
    });
  }

  warningAlert(msg: string): void {
    this.toastModel.Title = 'Warning';
    this.toastModel.Type = 'warning';
    this.toastModel.Message = msg;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 5000);
  }

  updateSectionLastEdited(filter: string): void {
    switch (filter) {
      case 'Assessor':
        this.isAssessmentLastEdited = true;
        this.updateIADetails.isAssessor = true;
        break;
    }
  }

  openBulkCloseDialog(): void {
    let itemids;
    if (this.impactAssessment.isMerged) {
      itemids = this.impactAssessment.merged_Id.replace('(', '');
      itemids = itemids.replace(')', '');
    }
    const dialogRef = this.dialog.open(BulkCloseDialogComponent, {
      width: '750px',
      data: itemids? itemids.split(",").map(Number):''
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.bulkCloseImpactAssessment(result, 'BulkClose');
      }
    });
  }

  bulkCloseImpactAssessment(regDetails: RegulationDetail, filter: string): void {
    this.isLoading = true;
    let selectedItems:any;
    if (this.impactAssessment.isMerged) {
      selectedItems = this.impactAssessment.merged_Id.replace('(', '')
      selectedItems = selectedItems.replace(')', '');
      selectedItems = selectedItems.split(",").map(Number)
    }
    this.bulkCloseData.itemIds = filter === 'BulkClose' ? selectedItems : regDetails.selectedLinkedIds;
    regDetails.userId = this.userAccessToken.externalUserId;
    regDetails.isRead = true;
    this.bulkCloseData.regulationDetail = regDetails;
    if (this.bulkCloseData.itemIds && this.bulkCloseData.itemIds.length > 50) {
      this.warningAlert('This operation may take a while to complete. The page will refresh upon completion. Please wait...');
    }
    this.bulkCloseData.regulationDetail.title = '';
    this.bulkCloseData.impactId = this.impactAssessment.id;
    this.regulationService.moveBulkImpactAssessmentT4BulkClose(this.bulkCloseData).subscribe((result: any) => {
      this.saveOnBrowser('_iadid', JSON.stringify(selectedItems));
      if (result.message === 'Saved Successfully') {
        this.alertMessage('success', 'Successfully updated');
        //Need to change here after Summary page is done.
        if (this.router.url.indexOf('/impact-assessment/details/') >= 0) {
          this.router.navigate([
            "/impact-assessment/summary/"
          ]);
        }
        else if (this.router.url.includes('/change-viewer')) {
          this.dialog.closeAll();
        }
      } else {
        this.warningAlert(result.message);
      }
      this.isLoading = false;
    });
  }

  saveOnBrowser(key: string, value: string): void {
    localStorage.setItem(key, value);
  }
  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
  uploadImportReport(): void {
    const fileInput = document.getElementById('importReport') as HTMLElement;
    fileInput.click();
  }
  handleImportFileInput(files: FileList): void {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < files.length; i++) {
      this.importReport(files[i]);
    }
  }

  importReport(fileToUpload: any): void {
    this.isLoading = true;
    this.impactService.uploadImportReport(fileToUpload, this.impactAssessmentId).subscribe((data: any) => {
      this.isLoading = false;
      this.impactAssessment = data;
      if (this.filterType !== 'version') {
        this.fetchIADetailsHistory();
      }
    }, (err: HttpErrorResponse) => {
      this.isLoading = false;
      this.alertMessage('warning', 'File not uploaded, please check your file');
      setTimeout(() => {
      }, 1000);
    });
  }
  downloadReport(): void {
    this.isLoading = true;
    this.downloadReportModel.id = this.impactAssessmentId;
    const parsedUrl = new URL(window.location.href);
    this.downloadReportModel.currentUrl = parsedUrl.origin;
    this.impactService.downloadIAReport(this.downloadReportModel)
      .subscribe((data: any) => {
        this.isLoading = false;
        // tslint:disable-next-line:one-variable-per-declaration
        const a = document.createElement('a'),
          fileURL = URL.createObjectURL(data);
        a.href = fileURL;
        a.download = `ImpactAssessmentReport.csv`;
        window.document.body.appendChild(a);
        a.click();
        window.document.body.removeChild(a);
      }, (err: HttpErrorResponse) => {
        this.isLoading = false;
        console.error(JSON.stringify(err.message));
      });
  }
  //previous next button add
  checkSibling(id: number, type: string): boolean {
    const index = this.idList.findIndex((a) => Number(a)=== Number(id));
    if (index < 0) {
      return false;
    } else {
      if (type === 'Next') {
        return this.idList[index + 1] ? true : false;
      } else {
        return this.idList[index - 1] ? true : false;
      }
    }
  }
  getSiblings(type: string): void {
    const index = this.idList.findIndex(
      (a) => Number(a) === Number(this.impactAssessmentId));
    if (type === 'Next') {
      this.impactAssessmentId = this.idList[index + 1];
    } else {
      this.impactAssessmentId = this.idList[index - 1];
    }
    this.redirectLink();
  }
  redirectLink() {
    let link = '/impact-assessment/details/impact/'+this.impactAssessment.templateNo+'/' + this.impactAssessmentId + '';
    const navigationExtras: NavigationExtras = {
      state: { idList: this.idList }
    };
   this.router.navigate([link], navigationExtras);
  }
}

export class Expertise {
  name!: string;
  color!: string;
}
